import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useMemo, useState } from 'react';
import { Utils } from 'record-it-utils/utils/Utils/Utils';
import { Breadcrumb, BreadcrumbsContext, BreadcrumbsContextValue } from '../../context/BreadcrumbsContext';
import { prepareProps } from '../../utils/propUtils';
export type BreadcrumbsProviderProps = PropsWithChildren<{
  initialBreadcrumbs?: Array<Breadcrumb>;
}>;
export const BreadcrumbsProvider: FunctionComponent<BreadcrumbsProviderProps> = React.memo(props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    initialBreadcrumbs,
    children
  } = t0;
  let t1;
  if ($[2] !== initialBreadcrumbs) {
    t1 = initialBreadcrumbs ?? [];
    $[2] = initialBreadcrumbs;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [breadcrumbs, setBreadcrumbs] = useState(t1);
  let t2;
  if ($[4] !== breadcrumbs) {
    t2 = newBreadCrumbs => {
      if (!Utils.isDeepEqual(newBreadCrumbs, breadcrumbs)) {
        setBreadcrumbs(newBreadCrumbs);
      }
    };
    $[4] = breadcrumbs;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== breadcrumbs || $[7] !== t2) {
    t3 = {
      breadcrumbs,
      setBreadcrumbs: t2
    };
    $[6] = breadcrumbs;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const contextValue = t3;
  let t4;
  if ($[9] !== children || $[10] !== contextValue) {
    t4 = <BreadcrumbsContext.Provider value={contextValue}>{children}</BreadcrumbsContext.Provider>;
    $[9] = children;
    $[10] = contextValue;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
});